import React from 'react';

function FacebookLightIcon() {
  const className = 'c-FacebookLightIcon';
  return (
    <svg
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fill="#fff"
        fillOpacity="0.88"
        d="M9.198 21.5h4v-8.01h3.604l.396-3.98h-4V7.5a1 1 0 011-1h3v-4h-3a5 5 0 00-5 5v2.01h-2l-.396 3.98h2.396v8.01z"
      ></path>
    </svg>
  );
}

export default FacebookLightIcon;
